import { FC } from 'react'

import { Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'

import { themeStyles } from 'themes'

import { IBlueAlert } from '../types'

const BlueAlertMessageComponent: FC<IBlueAlert> = ({ classes, header, children, marginTop }) => (
    <>
        {marginTop && <br />}
        <div className={classes.infoDetalsBox}>
            <Typography variant="h5" className={classes.infoDetalsBoxText}>
                <span className={classes.bankAccountInfoDetalsActiveColor}>{header}</span> {children}
            </Typography>
        </div>
    </>
)

export default withStyles(themeStyles.useAlertComponentsStyles)(BlueAlertMessageComponent)
